import {AbstractControl, ValidationErrors, ValidatorFn} from '@angular/forms';
import {RESERVED_NAME_CHARACTERS} from './globals';

export interface NameValidationResult {
    valid: boolean;
    error?: string;
}

export function validateEntityName(name: string, entityLabel: string = 'Folder'): NameValidationResult {
    const trimmed = (name || '').trim();
    if (!trimmed) {
        return {valid: false, error: `${entityLabel} name cannot be blank.`};
    }
    const reserved = RESERVED_NAME_CHARACTERS.filter(ch => trimmed.includes(ch));
    if (reserved.length) {
        return {
            valid: false,
            error: `${entityLabel} name cannot contain reserved characters: ${reserved.join(' ')}`,
        };
    }
    return {valid: true};
}

export function entityNameValidator(entityLabel: string = 'Folder'): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        const result = validateEntityName(control.value, entityLabel);
        return result.valid ? null : {entityName: {message: result.error}};
    };
}
